import { DataService } from "../../config/dataService";

const state = {
  foundLinks: [],
  data: {
    name: "",
    websiteLink: "",
    links: [],
    linkType: "",
  },
  updateData: {}
};

const mutations = {
  mutateStateData(state, data) {
    state.data = { ...state.data, ...data };
  },

  mutateFoundLinks(state, data) {
    state.foundLinks = data;
  },
  updateDataChange(state, data) {
    state.updateData = {...state.updateData, ...data}
  }
};

const actions = {
  updateCreateBotData({ commit }, data) {
    commit("mutateStateData", data);
  },

  updateDataChange({commit}, data) {
    commit('updateDataChange', data)
  },

  async getLinks({ commit }, { link, type }) {
    const { data } = await DataService.post(
      `${API_ENDPOINT}websites/getLinks`,
      {
        link,
        type,
      }
    );
    commit("mutateFoundLinks", data);
  },
};

const getters = {
  getData: (state) => state.data,
};

export default {
  state,
  mutations,
  actions,
  getters,
};
